import React from "react";
import Grid from "@material-ui/core/Grid";
import { sto } from "../../../../Context/InshData";
import {  useInvMain } from "../../../../St/Reviews/UseStyle";
import { colors } from "@material-ui/core";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";
function FooterM(props) {
    const { found, sta ,num} = props;
    const clasm = useInvMain();
    const styf = { fontWeight: "bold", fontSize: "0.75rem", direction: "rtl", };
    const styfE = { fontWeight: "bold", fontSize: "0.7rem", };
    const styfC = { fontSize: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular", paddingBottom: "0.3rem" };
    const styeNum = { fontWeight: "bold", textAlign: "center", color: colors.red[500], direction: "ltr" };
    const styleCenter = { fontWeight: "bold", textAlign: "center", fontSize: "1rem" };

    return (
        <Grid item container
            style={{ padding: 5, fontWeight: "bold", fontFamily: "Amiri-Regular", marginLeft: "0cm" }}
        >
            <Grid
                item
                container
                xs={12}
                style={{ fontWeight: "bold", }}
            >

                <Grid item xs={12} container  >
                    {num=== 31 ? (
                        <Grid item xs={12} container  >
                            <Grid item xs={3} >
                                <div style={styleCenter}>{"اجمالي الكميات"}</div>
                                {/* <br /> */}
                                <div style={styleCenter}>{"Qoantitys"}</div>
                                {/* <br /> */}
                                <div style={styeNum}>{sta?.info?.reduce(
                                    (sum, item) => Number(sum) + Number(item?.val1),
                                    0
                                )}</div>

                            </Grid>
                            <Grid   item  container   xs={9} style={styleFooterNotesAr} >
                                {found.BillNotes}
                            </Grid>

                        </Grid>
                    ) :
                        (
                            <>
                                <Grid item xs={6} className={clasm.minleft}>
                                    <div style={styfC}>{found.Disc1_footer_en}</div>
                                    <div style={styfE}>{found.Disc2_footer_en}</div>
                                    <div style={styfE}>{found.Disc3_footer_en}</div>
                                </Grid>

                                <Grid item xs={6} className={clasm.minrit}>
                                    <div style={styfC}>{found.Disc1_footer_ar}</div>
                                    <div style={styf}>{found.Disc2_footer_ar}</div>
                                    <div style={styf}>{found.Disc3_footer_ar}</div>
                                </Grid>
                            </>

                        )}

                    <Grid item xs={5} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                        {"توقيع المستلم" + "     " + " Receivrs Sign "}
                    </Grid>
                    <Grid item xs={5} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                        {" "}
                        {"  البائع" + "     " + " Salesmans Sign "}
                    </Grid>

                    <Grid item xs={2} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.3rem" }}>
                        {sto.usernames}
                    </Grid>
                </Grid>
            </Grid >
        </Grid >

    );
}
export default FooterM;

